const _ = require("lodash");

const settings = {
	staticMaxStars: true,
	neverResumeResult: true,
	canFinishOnStateChange: true,
	noUndoRedoClear: true,
	updatePercentCompleteOnStateChange: true,
	pauseWhenFailing: true,
	saveAllProblems: true,
	noProblemHistory: true,
	canEarnStarsOnStateChange: true,
	skipProblemCount: true,
};

const initialize = function(result, processor) {
	const currentProblem = result.problems[0];
	currentProblem.customState = processor.setupCustomState(
		currentProblem.model,
		currentProblem.customState
	);
};

const getStars = function(result) {
	const currentProblem = result.problems[0];
	const starCutoffs = getStarCutoffs(currentProblem.customState.maxScore);
	return starCutoffs.filter(
		cutoff => currentProblem.customState.highestScore >= cutoff
	).length;
};

const getStarCutoffs = function(maxScore) {
	return [maxScore / 3, (maxScore * 2) / 3, maxScore];
};

const isFinished = function(result) {
	const currentProblem = result.problems[0];
	return currentProblem.customState.numbersLeft <= 0;
};

const getTrialXP = function() {
	return 0;
};

const getResultProgressXP = function(backendResult) {
	// Don't get any XP for popping bubbles.
	const numPopped = _.get(
		backendResult,
		"progress.problems.0.customState.squaresCaptured.length",
		0
	);
	return numPopped * getTrialXP();
};

const getSummaryProblemsSolvedText = function(result) {
	const currentProblem = result.problems[0];
	const customState = currentProblem.customState;
	const numCaptured = customState.squaresCaptured.length;
	const numSquares = numCaptured + customState.squaresMissed.length;
	const numIncorrect = customState.nonSquaresCaptured.length;
	// gameTypeName is either "squares" or "primes", defaulting to "squares"
	const gameTypeName = customState.gameTypeName || "squares";
	let message =
		"You correctly captured " +
		numCaptured +
		" out of " +
		numSquares +
		" " +
		gameTypeName;
	if (numIncorrect) {
		const s = numIncorrect > 1 ? "s" : "";
		message += " and mistakenly popped " + numIncorrect + ` other number${s}!`;
	} else {
		message += " and didn't mistakenly pop any other numbers!";
	}
	return message;
};

const getPercentComplete = function(result) {
	const currentProblem = result.problems[0];
	return (
		currentProblem.customState.bestPossibleScore /
		currentProblem.customState.maxScore
	);
};

const getStarProgressInfo = function(result) {
	const starCutoffs = [1, 2 / 3, 1 / 3];
	return {
		styleType: result.styleType,
		filledAmount: (getStars(result) * 1) / 3,
		totalAmount: 1,
		allCutoffs: starCutoffs,
		starCutoffs,
		keepStarsReached: true,
	};
};

const getSummaryForReport = function(backendResult) {
	const customState = _.get(backendResult, "progress.problems[0].customState");
	if (!customState) {
		return "Problems cannot be displayed for this game lesson.";
	} else {
		const {squaresMissed, squaresCaptured, nonSquaresCaptured} = customState;
		return `${squaresCaptured.length} / ${squaresCaptured.length +
			squaresMissed.length +
			nonSquaresCaptured.length} squares correctly identified.`;
	}
};

module.exports = {
	settings,
	initialize,
	getStars,
	getStarCutoffs, //Used by the view as well as the RM
	isFinished,
	getTrialXP,
	getResultProgressXP,
	getSummaryProblemsSolvedText,
	getPercentComplete,
	getStarProgressInfo,
	getSummaryForReport,
};
